export default __webpack_public_path__ + "static/media/dentist (3).f138797c.jpg";